import { render, staticRenderFns } from "./QRGeneradorComponent.vue?vue&type=template&id=2c819498&scoped=true&"
import script from "./QRGeneradorComponent.vue?vue&type=script&lang=js&"
export * from "./QRGeneradorComponent.vue?vue&type=script&lang=js&"
import style0 from "./QRGeneradorComponent.vue?vue&type=style&index=0&id=2c819498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c819498",
  null
  
)

export default component.exports